import type React from 'react';

import Typography from '@core/Typography2';

export type Props = {
  id?: string;
  'aria-label'?: string;
  /**
   * The typography variant to use for the header label.
   * @default 'subtitleMedium'
   */
  typographyVariant?: 'subtitleMedium' | 'subtitleLarge' | 'subtitleSmall';
  children: React.ReactText;
};

const HeaderLabel = (props: Props) => {
  const { children, typographyVariant = 'subtitleMedium', ...rest } = props;

  return (
    <Typography component="span" variant={typographyVariant} {...rest}>
      {children}
    </Typography>
  );
};

export default HeaderLabel;
